// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"s7","hide":"s8"};